module.exports = __webpack_public_path__ + "img/logo-intl-expresstc.e247002.jpg";